import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Context } from './context';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (!Context.user) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
